import React, { useEffect, useState } from "react";

// ROUTER
import { withRouter } from "../../utils/withRouter";

// CANVAS
import IconTipsIllustrative from "canvas-core-react/lib/IconTipsIllustrative";
import Column from "canvas-core-react/lib/Column";
import BuddyTip from "canvas-core-react/lib/BuddyTip";
import TextBody from "canvas-core-react/lib/TextBody";
import TextField from "canvas-core-react/lib/TextField";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import ListItem from "canvas-core-react/lib/ListItem";
import UnorderedList from "canvas-core-react/lib/UnorderedList";

// COMPONENTS
import Layout from "../../components/Layout/Layout";
import Foot from "../../components/Layout/Foot";
import IconPlug from "../../components/icons/IconPlug";
import BrandLine from "../../components/BrandLine";

// UTILS
import { formatRut, validateRut } from "../../utils/utils";

// CONTEXT
import { useAppContext } from "../../AppProvider";

// STYLES
import "./style.scss";
import Banner from "../../components/Layout/Banner";

import BackContinue from "../../components/BackContinue";
import Margin from "canvas-core-react/lib/Margin";
import Link from "canvas-core-react/lib/Link";
import Simulator from "../Simulator";
import Row from "canvas-core-react/lib/Row";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import TextHeadline from "canvas-core-react/lib/TextHeadline";
import Card from "canvas-core-react/lib/Card";

import { CE_ACCEPTANCE_TEXT, CE_CONSENT, CE_DOCUMENT_VALIDATE } from '../../constants/endpoints'
import resolveEnv from '../../Helpers/resolveEnv'

import IconDefaultError from "../../components/icons/DefaultError";
import { clickTag, stepsTagging_1 } from "../../utils/tagging";

const DataEntry = ({ navigate }) => {
	const { state: context, changeItem } = useAppContext();
	const [showSimulator, setShowSimulator] = useState(false);
	const [text, setText] = useState('');
	const [document, setDocument] = useState('');
	const [responseCode, setResponseCode] = useState('');
	const [showError, setShowError] = useState(false);
	const {
		rut,
		error_rut,
	} = context;

	const rutChange = (event) => {
		const { value } = event.target;
		const splittedValue = value.split("-");
		let end = "";
		let start = "";
		if (splittedValue.length > 1) {
			start = splittedValue[0].replace(/[^0-9]/g, "");
			end = splittedValue[1].replace(/[k]/g, "K");
			end = end.replace(/[^zK0-9]/g, "");
		} else {
			start = value.substring(0, value.length - 1);
			end = value.charAt(value.length - 1);
			end = end.replace(/[k]/g, "K");
		}
		const rutWithoutFormat = start + end;
		const isValid = validateRut(start + "-" + end);
		const errorMsg = !isValid || rutWithoutFormat.length < 8 ? "Ingresa un RUT válido" : null;
		const errorObject = errorMsg && value ? {
			label: errorMsg,
			messages: [errorMsg]
		} : null;
		let rutformat = formatRut(rutWithoutFormat)
		rutformat = rutformat.replace(/\./g, '')
		setDocument(rutformat);
		changeItem({ rut: rutWithoutFormat, error_rut: errorObject });

	};

	const ce_TEXT_URL = `${resolveEnv(CE_ACCEPTANCE_TEXT)}`;
	const getTextUrl = () => fetch(ce_TEXT_URL, {
		method: 'GET',
		headers: {
			"Content-Type": "application/json",
			"x-channel": "SPUB",
		}
	})
		.then(response => response.json())
		.then(respomse => setText(respomse.acceptance_text))
		.catch(response => {
			setShowError(true);
		});

	const ceURLConsent = `${resolveEnv(CE_CONSENT)}`;
	const getUrlConsent = () => fetch(ceURLConsent, {
		method: 'POST',
		headers: {
			"Content-Type": "application/json",
			"x-channel": "SPUB"
		},
		body: JSON.stringify({
			customer_id: document
		}),

	})

	const ceURL = `${resolveEnv(CE_DOCUMENT_VALIDATE)}?customer-id=${document}`;
	const getUrl = () => fetch(ceURL, {
		method: 'GET',
		headers: {
			"Content-Type": "application/json",
			"x-channel": "SPUB",
		}
	})
		.then(response => response.json())
		.then(respomse => respomse.code)
		.catch(response => {
			setShowError(true);
		});

	const deshabilitarBtn = !rut || error_rut;
	const handleGetValidate = async () => {
		clickTag("validacion-usuario", "aceptar-y-continuar")
		try {
			const responseConsent = await getUrlConsent();
			const response = await getUrl();
			setShowError(false)
			response == 0 ?
				setShowSimulator(true) :
				response == 991 ?
					setShowError(response) :
					setShowError(true);
		}
		catch (error) {
			console.log(error)
			setShowError(true);
		}
	};

	useEffect(() => {
		getTextUrl();
		stepsTagging_1();
	}, []);
	return (
		<>
			<Layout idBlackBanner={0}
			>
				{!showError &&
					<Banner />}
				<Column lg={12} lgOffset={0}>
					{!showError &&
						<TextHeadline id="dataEntry_title_2" component="h1" size="small">Simula tu Depósito a Plazo</TextHeadline>
					}
					{!showError && !showSimulator && <>
						<TextBody id="dataEntry_subtitle" type="2" component="p">
							Primero necesitamos que ingreses tu Rut y validar que cumples con los
							requisitos necesarios para ofrecerte una <strong>tasa exclusiva</strong>
						</TextBody></>}
				</Column>
				{showError ?
					<Row justifyContent="center" style={{ textAlign: 'center' }}>
						<Column
							xs={4}
							sm={8}
							md={10}
							lg={10}
						>
							<Margin side="top" xs={90} sm={60} md={60} lg={60}>
								{showError === 991 ?
									<IconDefaultError /> :
									<IconPlug />
								}
							</Margin>
							<Margin side="top" xs={0} sm={24} md={24} lg={24}>
								<TextSubtitle type="1" component="h3">
									¡Vaya!
								</TextSubtitle>
								<TextSubtitle type="1" component="h3">
									{showError === 991 ? 'Ya eres cliente Scotia' : 'Ha ocurrido un error!'}
								</TextSubtitle>
							</Margin>
							<Margin side="top" xs={12} sm={24} md={24} lg={24}>
								<BrandLine />
							</Margin>
							<Margin xs={18} sm={36} md={0} lg={0}>
								<TextBody component="p">
									{showError === 991 ?
										<>
											Te invitamos a contratar tu Depósito a Plazo desde tu sitio privado.<br /> Si aún no tienes tu clave de acceso actívala para tu primer ingreso
										</> :
										'Por el momento hemos perdido la conexión, inténtalo nuevamente.'}
								</TextBody>
							</Margin>
							<Margin side="top" xs={12} sm={24} md={60} lg={60}></Margin>
							<PrimaryButton
								id={'buttonId'}
								labelPadding={36}
								style={{ width: '240px' }}
								onClick={() => {
									showError === 991 ?
										window.parent.location.href = 'https://www.scotiabank.cl/login/personas/'
										: handleGetValidate()
								}
								}
							>
								{showError === 991 ? 'Ir a página de ingreso' : 'Reintentar'}
							</PrimaryButton>
						</Column>
					</Row>
					:
					!showSimulator ?
						<>
							<div id="dataEntry_inputs_container">
								<Column lg={6} style={{ paddingTop: '18px' }}>
									<TextField
										id="dataEntry_rut"
										type="text"
										name="rut"
										label="RUT:"
										maxLength={12}
										value={formatRut(rut)}
										onChange={rutChange}
										placeholder="Ingresa tu RUT"
										error={error_rut}
									/>
								</Column>
								<Column lg={6}>
									<Card type='flatSolid' style={{ textAlign: 'left', padding: '18px 18px' }}>
										<TextBody component="p" type="2" bold style={{ fontSize: '14px' }}>
											Requisitos necesarios:
										</TextBody>
										<UnorderedList style={{ paddingLeft: '24px', fontSize: '1.4rem' }}>
											<ListItem>
												No ser cliente Scotia
											</ListItem>
											<ListItem>
												Ser mayor de 18 años
											</ListItem>
											<ListItem>
												Cédula de identidad vigente
											</ListItem>
											<ListItem>
												Ser persona natural
											</ListItem>
										</UnorderedList>
									</Card>
								</Column>
							</div>
							<div id="dataEntry_checkbox_container">
								<span id="dataEntry_checkbox_text">

									<TextBody type="2" component="p">
										Confirmo que he leído y autorizo a Scotiabank el uso y tratamiento de mis datos personales conforme con los términos expresados en el {" "}
									<Link
										type="emphasis"
										href="https://www.scotiabankchile.cl/Personas/politica-de-privacidad?_ga=2.18034554.294593437.1645467835-368161388.1621968918\"
										target="_blank"
										onClick={()=>clickTag("validacion-usuario", "acuerdo-de-privacidad")}
										>
										Acuerdo de Privacidad
									</Link></TextBody>
								</span>
							</div>
							<BackContinue
								continueId="dataEntry_btn_continue"
								continueDisabled={deshabilitarBtn}
								handleContinue={handleGetValidate}
								withBack={false}
							/>
							<div>
								<Column lg={12} style={{ width: "100%" }}>
									<Row >
										<BuddyTip
											Icon={IconTipsIllustrative}
											iconSize={36}
											className="DataEntry_BuddyTip"
										>
											<TextBody type="2" component="p">
												Podrás pagar el monto inicial de tu Depósito a Plazo desde {" "}
												<strong style={{ fontFamily: "Scotia Bold" }}>otros bancos (BCI)  de manera 100% digital</strong>
											</TextBody>
										</BuddyTip>
									</Row>
								</Column>
							</div>
						</> :
						<Simulator document={document} setShowError={setShowError} showError={showError} />
				}
			</Layout>

			<Foot />
		</>
	);
}

export default withRouter(DataEntry);